"use client";

import { phiModuleClientContributions as m_phis_dev_client } from "@phis/dev/client";
import { collectPhiSiteModuleClientContributions } from "@phis/ui/module/projection/client";

/**
 * Generated by `phis module`. Do not edit.
 * The public Area's Client counterpart of `site-modules.ts`.
 *
 * Only the packages with a Module for this Area are imported, and only through their Client
 * door: a bundler packs whatever a value here can reach, so a Module another Area serves -- or
 * a package's whole definition -- would otherwise ride along on every page of this one.
 * Carries no Authoring import either; that half lives in `site-modules-authoring-client.ts`.
 */
export const PHI_SITE_MODULES_CLIENT = collectPhiSiteModuleClientContributions({
  placements: [
    { moduleId: "@phis/dev/modules/site", eligibleAreas: ["public"] },
  ],
  clients: [m_phis_dev_client],
});
